/**
 * quote-popup.js
 *
 * 弹窗询盘流程（v5 — iframe 展示 + 父页面表单弹窗）：
 * 1. srcdoc iframe 加载产品页（保留原始布局，含表单区域）
 * 2. iframe 内 "Get Quote" 按钮被拦截 → postMessage 发送产品信息到父页面
 * 3. 父页面收到消息 → 打开表单弹窗（原生 {% form 'contact' %}，hCaptcha 自动注册）
 * 4. 用户手动填写 + 点击提交 → Shopify 原生 CAPTCHA 处理
 */
if (!customElements.get('quote-popup-button')) {
  class QuotePopupButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      const modalId = this.getAttribute('data-modal-id');
      this.modal = document.getElementById(modalId);
      this.formModal = document.getElementById('quote-form-modal');

      if (this.modal) {
        this.iframe = this.modal.querySelector('iframe');
        this.loader = this.modal.querySelector('.quote-iframe-modal__loader');
        this.closeBtn = this.modal.querySelector('.quote-iframe-modal__close');
      }

      this.productUrl = this.getAttribute('data-product-url');

      if (this.button) this.button.addEventListener('click', this.openPopup.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closePopup.bind(this));
      if (this.modal) this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.closePopup(); });

      // 表单弹窗关闭
      if (this.formModal) {
        const formCloseBtn = this.formModal.querySelector('.quote-form-modal__close');
        if (formCloseBtn) formCloseBtn.addEventListener('click', () => this.closeFormModal());
        this.formModal.addEventListener('click', (e) => { if (e.target === this.formModal) this.closeFormModal(); });
      }

      window.addEventListener('message', this.handleMessage.bind(this));
    }

    async openPopup() {
      if (!this.productUrl) return;
      if (this.modal) { this.modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      if (this.loader) this.loader.classList.remove('hidden');

      try {
        let url = this.productUrl;
        if (!url.includes('view=popup')) url += (url.includes('?') ? '&' : '?') + 'view=popup';
        url += (url.includes('?') ? '&' : '?') + '_t=' + Date.now();

        const response = await fetch(url);
        let html = await response.text();

        // 注入 CSS：移动端适配 + iframe 标记
        const injectedCSS = `<style>
          @media (max-width: 1024px) {
            html, body { overflow-x: hidden !important; }
            .full-width { padding-left: 12px !important; padding-right: 12px !important; }
            .custom-product-layout-wrapper { gap: 12px !important; margin-top: 12px !important; margin-bottom: 12px !important; }
            .custom-column-options #ymq-box { display: block !important; overflow-x: visible !important; }
            .custom-column-options #ymq-box .ymq-option { flex: none !important; width: 100% !important; max-width: 100% !important; margin-bottom: 12px !important; padding: 12px !important; box-sizing: border-box !important; }
            .custom-column-summary { width: 100% !important; }
          }
        </style>`;
        html = html.replace('</head>', injectedCSS + '<meta name="x-quote-iframe" content="true">' + '</head>');

        this.iframe.srcdoc = html;
        this.iframe.onload = () => { if (this.loader) this.loader.classList.add('hidden'); };
      } catch (err) {
        console.error('Failed to load popup:', err);
        if (this.loader) this.loader.classList.add('hidden');
      }
    }

    handleMessage(event) {
      if (!event.data || event.data.type !== 'quote-form-submit') return;
      if (this.iframe && event.source !== this.iframe.contentWindow) return;

      const { formData } = event.data;

      if (this.formModal) {
        const form = this.formModal.querySelector('form');
        if (form) {
          // 动态填充所有产品信息字段
          for (const [name, value] of Object.entries(formData)) {
            let input = form.querySelector(`[name="${name}"]`);
            if (!input) {
              // 不存在的字段（如 Product Options、Quantity、Total Price）动态创建
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = name;
              form.appendChild(input);
            }
            input.value = value;
          }
        }
        // 打开表单弹窗
        this.formModal.classList.add('is-open');
      }
    }

    closePopup() {
      if (this.modal) { this.modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    }

    closeFormModal() {
      if (this.formModal) { this.formModal.classList.remove('is-open'); }
    }
  }
  customElements.define('quote-popup-button', QuotePopupButton);
}
